import { applyDexFilters, fromLegacy } from './dexFilters';

export function filterDex(entries, options = {}) {
  const modern = options.join || options.types || options.letter || options.categories
    || options.statMin || options.moves || options.abilities;
  return applyDexFilters(entries, modern ? { ...fromLegacy({}), ...options } : fromLegacy(options));
}

export function formatMeters(value) {
  return typeof value === 'number' ? `${value.toFixed(1)} m` : '—';
}

export function formatKilograms(value) {
  return typeof value === 'number' ? `${value.toFixed(1)} kg` : '—';
}

export function formatUsage(value) {
  return typeof value === 'number' ? `${value.toFixed(1)}%` : '—';
}

export const TYPE_OPTIONS = [
  'normal', 'fire', 'water', 'electric', 'grass', 'ice',
  'fighting', 'poison', 'ground', 'flying', 'psychic', 'bug',
  'rock', 'ghost', 'dragon', 'dark', 'steel', 'fairy',
];

export function detailPath(entry) {
  if (!entry) return '';
  if (entry.mega || entry.primal) return entry.slug;
  return entry.id ?? entry.slug ?? '';
}

export function artworkUrl(id) {
  if (!id) return '';
  return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`;
}

export const GENERATION_OPTIONS = [
  [1, 'Gen 1 · Kanto'],
  [2, 'Gen 2 · Johto'],
  [3, 'Gen 3 · Hoenn'],
  [4, 'Gen 4 · Sinnoh'],
  [5, 'Gen 5 · Unova'],
  [6, 'Gen 6 · Kalos'],
  [7, 'Gen 7 · Alola'],
  [8, 'Gen 8 · Galar'],
  [9, 'Gen 9 · Paldea'],
];
